angular.module('pitch.app')

.factory('ABCFilterModal', function(config, Modal) {
    return {
        open: function(params, data) {
            Modal.create(
                config.templateRoot + '/templates/modals/abcfilter',
                params,
                data
            );
        }
    };
})

;



// WEBPACK FOOTER //
// ./src/AppBundle/Resources/js/angular/services/ABCFilterModal.js